import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { APP_STORE_URL, GOOGLE_PLAY_URL } from '../constants';

export default function DownloadCards() {
  return (
    <div className="downloads" id="download">
      <div className="download-col">
        <a href={APP_STORE_URL} target="_blank" rel="noreferrer">
          <img className="store-badge-img" src="/images/app_store_badge_564x168.png" alt="Download on the App Store" />
        </a>
        <a href={APP_STORE_URL} target="_blank" rel="noreferrer" className="qr-mini" aria-label="Download on the App Store">
          <QRCodeSVG value={APP_STORE_URL} size={144} bgColor="#ffffff" fgColor="#0f172a" />
        </a>
      </div>

      <div className="download-col">
        <a href={GOOGLE_PLAY_URL} target="_blank" rel="noreferrer">
          <img className="store-badge-img" src="/images/google_play_badge_trimmed_564x168.png" alt="Get it on Google Play" />
        </a>
        <a href={GOOGLE_PLAY_URL} target="_blank" rel="noreferrer" className="qr-mini" aria-label="Get it on Google Play">
          <QRCodeSVG value={GOOGLE_PLAY_URL} size={144} bgColor="#ffffff" fgColor="#0f172a" />
        </a>
      </div>
    </div>
  );
}
